import { OverflowMenuProps } from './overflow-menu.model';
import { OverflowMenuView } from './overflow-menu.view';

export const OverflowMenuController = (props: OverflowMenuProps) => {
  return <OverflowMenuView {...props} />;
};
